export const SIDE_SCROLLER = 'side-scroller'
export default SIDE_SCROLLER
